module.exports = __webpack_public_path__ + "img/speech_13.d69c7857.jpeg";